import { FC } from 'react'
import { css } from '@emotion/react'
import { palette } from '@lifedot/styles/palette'
import { typography } from '@lifedot/styles/typography'
import { CampaignBanner } from '@lifedot/components/CampaignBanner'

const styles = {
  root: css({
    backgroundColor: palette.gray1,
    padding: '16px 20px',
    borderRadius: 4,
    p: {
      margin: 0
    }
  }),
  title: css({
    color: palette.main03,
    fontWeight: 'bold'
  }),
  list: css({
    fontWeight: 'bold',
    counterReset: 'number 0',
    li: {
      marginTop: 12,
      position: 'relative',
      paddingLeft: 24,
      '::before': {
        position: 'absolute',
        top: 1,
        left: 0,
        counterIncrement: 'number 1',
        content: 'counter(number) ". "',
        color: palette.main
      }
    }
  }),
  banner: css({
    marginTop: 20
  })
}

interface TocProps {
  toc: { id: string; title: string }[]
}

export const Toc: FC<TocProps> = ({ toc }) => {
  return (
    <>
      <div css={styles.root}>
        <p css={[typography.textS, styles.title]}>この記事の目次</p>
        <ol css={styles.list}>
          {toc.map(({ id, title }) => (
            <li key={id} css={typography.textS}>
              <a href={`#${id}`}>{title}</a>
            </li>
          ))}
        </ol>
      </div>
      <div css={styles.banner}>
        <CampaignBanner />
      </div>
    </>
  )
}
